

export interface Foundation {
  readonly id: number;
  name?: string;
  state?: string;
  color?: string;
  websiteUrl?: string;
  applicationUrl?: string;
}
